import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Sort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, map, Observable } from 'rxjs';
import { ConfirmDialogComponent, Logger, OrganizationService } from 'src/app/@shared';
import { DEFAULT_SNACKBAR_CONFIG } from 'src/app/@shared/constants/site.constants';
import { OfferAsset, ProductAssetsService, ProductAddAssetComponent, VersionAssetsService, VersionAddAssetComponent } from '../..';

const log = new Logger('ProductAssetListComponent');

@Component({
  selector: 'app-version-asset-list',
  templateUrl: './version-asset-list.component.html',
  styleUrls: ['./version-asset-list.component.scss']
})

export class VersionAssetListComponent implements OnInit {

  viewModel$ = combineLatest([
    this.versionassetService.assets$,
    this.versionassetService.isLoading$,
    this.versionassetService.page$,
    this.versionassetService.versionId$,
    this.organizationService.assetsUrl$,
    this.versionassetService.totalRecords$
  ]).pipe(
    map(([assets, isLoading, page, versionId, assetsUrl, totalRecords]) => {
      if (assets.length == 0 && page.pageIndex > 0) {
        page.previousPageIndex = 0
        page.pageIndex = 0
        this.versionassetService.page(page);
        this.versionassetService.reload();
        }
      return { assets, isLoading, page, versionId, assetsUrl, totalRecords }
    }),
  );

  filtersForm = new FormGroup({
    search: new FormControl(),
  });
  assetsList: OfferAsset[] = [];
  assetsUrl$: Observable<string> = this.organizationService.assetsUrl$;
  selection = new SelectionModel<OfferAsset>(true, []);

  constructor(private versionassetService: VersionAssetsService<OfferAsset>,
    private organizationService: OrganizationService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private router: Router,
    private matSnackBar: MatSnackBar) { }

  ngOnInit(): void {
    log.debug('init');
    this.clearSearch();
    // get the version id from the parent route
    this.versionassetService.versionId = this.route.snapshot.params['versionId'];
  }

  onSort(sortState: Sort): void {
    this.versionassetService.sort(sortState);
    this.selection.clear();
  }

  onPage(pageEvent: PageEvent): void {
    this.selection.clear();
    this.versionassetService.page(pageEvent);
  }

  onSearch(event: any) {
    this.versionassetService.search(event.target.value);
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(VersionAddAssetComponent, {
      width: '80%',
      height: '90%',
      data: { versionId: this.route.snapshot.params['versionId'] }
    });
  }

  diassociateAssets() {
    if (this.selection && this.selection.selected && this.selection.selected.length > 0) {
      let assets: any = this.selection.selected.map(x => x.Detail.Id);
      const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
        data: {
          title: 'Confirm Delete',
          message: `Do you want to remove selected asset(s)?`,
        },
        disableClose: true,
      });

      confirmDialog.afterClosed().subscribe(
        confirmResult => {
          if (confirmResult) {
            this.versionassetService.disassociateAssetToVersion(assets).subscribe({
              next: () => {
                this.matSnackBar.open(`Asset deleted`, 'OK', DEFAULT_SNACKBAR_CONFIG);
                this.versionassetService.reload();
                this.router.navigate([`../`, `version-assets`], { relativeTo: this.route });
              },
              error: (error) => {
                log.error('Error deleting asset to version', error);

                if (error.error.value) {
                  throw new Error(error.error.value);
                } else {
                  throw new Error(error.message);
                }
              }
            });
          }
        });
    }
  }

  clearSearch() {
    this.filtersForm.controls.search.setValue('');
    this.versionassetService.search('');
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.assetsList.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.assetsList.forEach(row => this.selection.select(row));
  }

  public getSelectedSectionRecords() {
    return this.selection.selected;
  }

  public clearSelection() {
    this.selection.clear();
  }

  public getImageSrc(assetsUrl: any, assets: any) {
    let imagesrc = '';
    if (assets.Type === 'application/pdf') {
      imagesrc = './assets/images/pdf.png';
    } else if (assets.Type.indexOf('audio') > -1) {
      imagesrc = './assets/images/mp3.jpg';
    } else if (assets.Type.indexOf('video') > -1) {
      imagesrc = './assets/images/mp4.png';
    } else if (assets.Type.indexOf('text') > -1) {
      imagesrc = './assets/images/text.png';
    }
    else {
      imagesrc = assetsUrl + '/' + assets.Detail.FileName;
    }
    return imagesrc;
  }


}
